import { useContext } from 'react'

import { AppContext, type IAppContext } from './AppContext'

export type IUseAppState = IAppContext

const useAppState = (): IUseAppState => {
  const appContext = useContext(AppContext)

  return appContext
}

export default useAppState
